import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const GuestInformation = ({ guestInfo, onGuestInfoChange }) => {
  const handleInputChange = (field, value) => {
    onGuestInfoChange({
      ...guestInfo,
      [field]: value
    });
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden shadow-lg">
      {/* Header */}
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
          <Icon name="User" size={24} className="text-primary" />
          Guest Information
        </h2>
        <p className="text-sm text-muted-foreground mt-1">Please provide traveler details for this booking</p>
      </div>

      {/* Form */}
      <div className="p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            type="text"
            label="First Name"
            placeholder="Juan"
            value={guestInfo?.firstName}
            onChange={(e) => handleInputChange('firstName', e?.target?.value)}
            required
          />

          <Input
            type="text"
            label="Last Name"
            placeholder="Dela Cruz"
            value={guestInfo?.lastName}
            onChange={(e) => handleInputChange('lastName', e?.target?.value)}
            required
          />
        </div>

        <Input
          type="email"
          label="Email Address"
          placeholder="juan.delacruz@example.com"
          value={guestInfo?.email}
          onChange={(e) => handleInputChange('email', e?.target?.value)}
          description="Booking confirmation will be sent to this email"
          required
        />

        <Input
          type="tel"
          label="Phone Number"
          placeholder="+63 917 123 4567"
          value={guestInfo?.phone}
          onChange={(e) => handleInputChange('phone', e?.target?.value)}
          description="For booking updates and property contact"
          required
        />

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            Special Requests (Optional)
          </label>
          <textarea
            className="flex min-h-[100px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder="Any special requests or requirements? (e.g., early check-in, dietary restrictions, accessibility needs)"
            value={guestInfo?.specialRequests}
            onChange={(e) => handleInputChange('specialRequests', e?.target?.value)}
          />
          <p className="text-xs text-muted-foreground">
            Special requests are subject to availability and may incur additional charges
          </p>
        </div>

        {/* Info Box */}
        <div className="p-4 bg-primary/5 rounded-lg border border-primary/20">
          <div className="flex items-start gap-3">
            <Icon name="Shield" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-1">Your Information is Secure</h4>
              <p className="text-xs text-muted-foreground">
                We use industry-standard encryption to protect your personal information. Your data will only be shared with the property for booking purposes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestInformation;